module.exports = __webpack_public_path__ + "static/benefits_three-1fa645b8f5250dc65c82a16de5a7af6d.png";